import {
  START_LOADING,
  END_LOADING,
  FETCH_NOTIFICATIONS,
  CREATE_NOTIFICATION,
  UPDATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  FETCH_NOTIFICATION,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  notifications: [],
  notification: null,
  currentPage: 1,
  numberOfPages: 1,
  totalItems: 0,
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };

    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload.data,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
        totalItems: action.payload.totalItems,
      };

    case FETCH_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };

    case CREATE_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };

    case UPDATE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          notification._id === action.payload._id ? action.payload : notification
        ),
      };

    case DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification._id !== action.payload
        ),
      };

    default:
      return state;
  }
};

export default notificationsReducer;
